// extracted by mini-css-extract-plugin
module.exports = {"layout":"fhs-brand_layout__INQ6Y","brand":"fhs-brand_brand__2WC0T","sector":"fhs-brand_sector__bVuLg"};